import React, { useState, useEffect } from "react";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { Button, Empty } from "antd";

import "./superuser.scss";

import superUseStatsStore from "../../store/superuser.store";
import SuperUserTableSelectable from "../SuperUserTableSelectable";
import SuperUserPlanTableSelectable from "../SuperUserPlanTableSelecable";
import SuperUserPriceTableSelectable from "../SuperUserPriceTableSelectable";
import SuperAdminPriceTableSelectable from "../SuperAdminPriceTableSelectable";

import moment from 'moment'
import QuallyhireProductAnalytics from "./analytics/quallyhireProductAnalytics";
import { SUBSCRIPTION_DETAILS_TABLE_COLUMNS_WIDTH, SUBSCRIPTION_TABLE_COLUMNS_WIDTH } from "../../helper/tablewidthcontants";

const summaryListTable = [
    "Select",
    "Sr. No.",         
    "Company Name",   
    "Super Admin Name",
    "Super Admin Phone",     
    "Super Admin Email",
    "Signup Date",
    "Plan Name",
    "Signup Status",
    "Document Verification", 
    "Trial Status",  
    "Subscription Status", 
    "Payment Status",     
];

const documentsListTable = [
    "Select",    
    "Sr. No.",
    "Company Name",
    "Company Type",
    "Super Admin Name",
    "Super Admin Phone",     
    "Super Admin Email",
    "Onboarding Date",
    "Product SignOn",
    "Status",
    "Document Type",
    "Document",
];

const freeListTable = [
    "Select",
    "Sr. No.",
    "Company Name",
    "SuperAdmin Name",
    "Company Type",
    "Plan Name",
    "Trial Period",
    "Trial Period Start Date",
    "Trial Period End Date",
    "Status" // INACTIVE, TP_ACTIVE,TP_EXPIRED,SP_ACTIVE,SP_EXPIRED
];

const subscriptionListTable = [
    "Select",
    "Sr. No.",
    "Company Name",
    "SuperAdmin Name",
    "Plan Name",
    "Duration",
    "Plan Amount",
    "Normal Discount",
    "Referral Discount",
    "Final Price",
    "Start Date",
    "End Date",
    "Payment Status",  
    "Subscription Status", 
];

const paymentListTable = [
    "Select",
    "Sr. No.",
    "Company Name",
    "SuperAdmin Name",
    "Plan Name",
    "Subscription Status", 
    "Payment Status",     
    "Amount Due",
    "Amount Paid",
    "Reference Number",
    "Bank Name",
    "Payment Date",
    "Download Invoice",
    "Generate Invoice"
];

const planListTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "Trial Period",
    "No of Users",
    "No of Resumes",
    "No of JDs",
    "1 Month Price",    
    "3 Months Price",
    "6 Months Price",
    "Yearly Price", 
    "Additional User Price" ,  
    "Additional Resumes Price",    
    "Additional JDs Price",
    "Vendor Connect",        
];

const mySubscriptionTable = [
    "Select",
    "Sr. No.",
    "Plan Name", 
    "Type", 
    "Status",
    "Duration",
    "Start Date",
    "End Date",
    "Due Amount",
    "Payment Status",
    "Payment Date",
    "Bank Name",
    "Reference Number"    
];
const myplanTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "No of Users",
    "No of Resumes",
    "No of Jb Posts",
    "Vendor Connect",    
];

export default function SuperUser() {
    const [currentView, setCurrentView] = useState("analytics");
    const moment = require('moment');
    const { superUserInfo,getSuperUserInfo ,getSuperUserAnalytics,superAdminInfo,getSuperAdminInfo,superUserUpdateflag,resetSuperUserUpdateFlag} = superUseStatsStore();
    useEffect(() => {
        if(superUserUpdateflag){
            getSuperUserInfo("All");
            getSuperAdminInfo("All");
            resetSuperUserUpdateFlag();
        }
    }, [superUserUpdateflag]);
    useEffect(() => {
            getSuperUserInfo("All");
            getSuperAdminInfo("All");
            getSuperUserAnalytics("All")
            resetSuperUserUpdateFlag();
    }, []);
    const statsData = superUserInfo?.stats?.map((comp, idx) => {
        return {
            select:"",
            id: idx+1,
            name: comp?.companyname,
            jds:  comp?.totaljds,
            resumes: comp?.totalresumes,
            users: comp?.totalusers,
            vendors:  comp?.totalvendors,
            customers: comp?.totalcustomers,
        };
    });   

    const getOnBoardingStatus =(status)=>{
        if(status === "account_created"){return "ACCOUNT CREATED"}
        if(status === "signup_otp_verification_pending"){return "OTP VERIFICATION PENDING"}
        if(status === "signup_account_verified"){return "VERIFIED"}
        if(status === "account_deleted"){return "ACCOUNT DELETED"}
        if(status === "account_suspended"){return "ACCOUNT SUSPENDED"}           
    } 
    const getPaymentStatus =(status)=>{
        if(status === "payment_none"){return "NA"}
        if(status === "payment_req"){return "REQUEST PAYMENT"}
        if(status === "payment_revise"){return "REVISE PAYMENT"} 
        if(status === "payment_declined"){return "DECLINED PAYMENT"}
        if(status === "payment_done"){return "PAYMENT DONE"}        
    }
    const getSubType =(status)=>{
        const version_array = status.split('_')
        if(version_array[0] === "trial"){return "TRIAL"}
        if(version_array[0] === "subscription"){return "SUBSCRIPTION"}     
    }
    const getPlanName =(idx,type,qhoid)=>{
        if(superUserInfo?.subscriptionstats == null){
            return superUserInfo?.freestats?.[idx]?.shistory?.[0].planname
        }   
        if(superUserInfo?.freestats == null){
            return superUserInfo?.subscriptionstats?.[idx]?.shistory?.[0].planname
        }  
        //if both are not null
        if(type == "TRIAL"){
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.freestats?.[index]?.companyid == qhoid){
                    return superUserInfo?.freestats?.[index].shistory?.[0].startdate
                }
            }
        }else{
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.subscriptionstats?.[index]?.companyid == qhoid){
                    return superUserInfo?.subscriptionstats?.[index].shistory?.[0].startdate
                }
            } 
        }        
    }
    const getPlanID =(idx,type,qhoid)=>{
        
        if(superUserInfo?.subscriptionstats == null){
            return superUserInfo?.freestats?.[idx].shistory?.[0].subid
        }   
        if(superUserInfo?.freestats == null){
            return superUserInfo?.subscriptionstats?.[idx].shistory?.[0].subid
        } 
        //if both are not null
        if(type == "TRIAL"){
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.freestats?.[index]?.companyid == qhoid){
                    return superUserInfo?.freestats?.[index].shistory?.[0].startdate
                }
            }
        }else{
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.subscriptionstats?.[index].companyid == qhoid){
                    return superUserInfo?.subscriptionstats?.[index].shistory?.[0].startdate
                }
            } 
        }         
    }
    const getEndDate =(idx,type,qhoid)=>{
        if(superUserInfo?.subscriptionstats == null){
            return superUserInfo?.freestats?.[idx].shistory?.[0].enddate
        }   
        if(superUserInfo?.freestats == null){
            return superUserInfo?.subscriptionstats?.[idx].shistory?.[0].enddate
        } 
                //if both are not null
        if(type == "TRIAL"){
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.freestats?.[index]?.companyid == qhoid){
                    return superUserInfo?.freestats?.[index].shistory?.[0].startdate
                }
            }
        }else{
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.subscriptionstats?.[index]?.companyid == qhoid){
                    return superUserInfo?.subscriptionstats?.[index].shistory?.[0].startdate
                }
            } 
        } 
    }
    const getStartDate =(idx,type,qhoid)=>{
        if(superUserInfo?.subscriptionstats == null){
            return superUserInfo?.freestats?.[idx].shistory?.[0].startdate
        }   
        if(superUserInfo?.freestats == null){
            return superUserInfo?.subscriptionstats?.[idx].shistory?.[0].startdate
        }  

        //if both are not null
        if(type == "TRIAL"){
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.freestats?.[index]?.companyid == qhoid){
                    return superUserInfo?.freestats?.[index].shistory?.[0].startdate
                }
            }
        }else{
            for(let index = 0; index < superUserInfo?.freestats?.length; index++){
                if(superUserInfo?.subscriptionstats?.[index]?.companyid == qhoid){
                    return superUserInfo?.subscriptionstats?.[index].shistory?.[0].startdate
                }
            } 
        }
    }
    const extraData = superUserInfo?.adminstats?.map((comp, idx) => {
        var stype = comp.subscriptionstatus == "subscription_none"?"TRIAL":"SUBSCRIPTION"
        var subID = getPlanID(idx,stype,comp?.companyid)
        return {
            qhoid: comp?.companyid,
            subID: subID,
            startdatets:getStartDate(idx),
            enddatets:getEndDate(idx),        
        };
    });  
    const summaryData = superUserInfo?.adminstats?.map((comp, idx) => {
        var planName = getPlanName(idx)
        return {
            select:"--",
            id: idx+1,
            name: comp?.companyname,
            aname:  comp?.name,
            aphone: comp?.phone,            
            aemail: comp?.email,
            date: comp?.onboardingdate,
            pname: planName,
            accountstatus:comp?.accountstatus, 
            docstatus:comp?.docstatus, 
            trialstatus:comp?.trialstatus, 
            substatus:comp?.subscriptionstatus, 
            paymentstatus:comp?.paymentstatus,                  
        };
    });  
    
    const documentsListData = superUserInfo?.adminstats?.map((comp, idx) => {
        return {
            select:"",            
            id: idx+1,
            name: comp?.companyname,
            companytype: comp?.companytype,
            aname:  comp?.name,
            aphone: comp?.phone,            
            aemail: comp?.email,
            date: comp?.onboardingdate,
            product: comp?.productsignon,  
            docstatus:comp?.docstatus,          
            documenttype: comp?.documenttype,
            document: comp?.doccontent
        };
    });  
    const convertDateFromTStoDate = (ts) =>{
        if(ts !=""){
            var date = new Date(ts * 1000);
            return moment(date).format('YYYY.MM.DD');

        }else{
            return ""
        }   
    }

    const isDocumentVerified = (companyid) =>{
        const company = superUserInfo?.adminstats?.find((comp) => comp?.companyid === companyid);
        if(company?.docstatus === "doc_verified"){return true}
        return false
    }

     const getfreeExtraData = () =>{
        var stats
        var index =0
        var freeListData=[{}]
        for(let idx = 0; idx < superUserInfo?.freestats?.length; idx++){
            if(isDocumentVerified(superUserInfo?.freestats?.[idx]?.companyid)){
                stats = superUserInfo?.freestats[idx] 
                freeListData[index]={}
                freeListData[index].qhoid = stats?.companyid
                freeListData[index].subID = stats?.shistory?.[0].subid
                index= index+1
            }
        }
        return freeListData
    }
    const getfreeListData = () =>{
        var stats
        var index =0
        var freeListData=[{}]

        for(let idx = 0; idx < superUserInfo?.freestats?.length; idx++){
            if(isDocumentVerified(superUserInfo?.freestats?.[idx]?.companyid)){
                stats = superUserInfo?.freestats[idx] 
                freeListData[index]={}
                freeListData[index].select = ""
                freeListData[index].id = idx+1
                freeListData[index].name = stats?.companyname
                freeListData[index].aname = stats?.adminname
                freeListData[index].companytype = stats?.companytype
                freeListData[index].planname = stats?.shistory?.[0].planname
                freeListData[index].trialperiod = stats?.shistory?.[0].trialperiod==0?"--":stats?.shistory?.[0].trialperiod
                freeListData[index].startdate = convertDateFromTStoDate(stats?.shistory?.[0].startdate)
                freeListData[index].enddate = convertDateFromTStoDate(stats?.shistory?.[0].enddate)
                freeListData[index].trialstatus = stats?.shistory?.[0].status
                index= index+1
            }
        }
        return freeListData
    }
    const getSubListData = () =>{
        var stats
        var index=0
        var subListData=[{}]

        for(let idx = 0; idx < superUserInfo?.subscriptionstats?.length; idx++){
            if(isDocumentVerified(superUserInfo?.subscriptionstats?.[idx]?.companyid)){
                stats = superUserInfo?.subscriptionstats[idx] 
                subListData[index]={}
                subListData[index].select = ""
                subListData[index].id = idx+1
                subListData[index].name = stats?.companyname
                subListData[index].companytype = stats?.companytype
                subListData[index].aname = stats?.adminname
                subListData[index].subID = stats?.shistory?.[0].subid
                subListData[index].planname = stats?.shistory?.[0].planname
                subListData[index].duration = stats?.shistory?.[0].duration + " Months"
                subListData[index].startdate = convertDateFromTStoDate(stats?.shistory?.[0].startdate)
                subListData[index].enddate = convertDateFromTStoDate(stats?.shistory?.[0].enddate)
                subListData[index].paymentstatus =stats?.shistory?.[0].paymentstatus
                subListData[index].substatus =  stats?.shistory?.[0].status
                subListData[index].planamount = stats?.shistory?.[0].planamount
                subListData[index].ndiscount = stats?.shistory?.[0].discount
                subListData[index].rdiscount = stats?.shistory?.[0].discount
                subListData[index].finalprice = stats?.shistory?.[0].planamount
                index = index+1
            }
        }
        return subListData
    }
    const paymentListData = superUserInfo?.subscriptionstats?.map((stats, idx) => {
        return {
            select:"",
            id:idx+1,
            name: stats?.companyname,
            aname:  superUserInfo?.adminstats?.[idx]?.name,
            planname: stats?.shistory?.[0].planname,
            substatus: stats?.shistory?.[0].type,
            paymentstatus: stats?.shistory?.[0].paymentstatus,
            planamount:stats?.shistory?.[0].planamount,
            paymentamount: stats?.shistory?.[0].paymentamount,
            referencenumber: stats?.shistory?.[0].paymentmethod,
            bankname:"",
            paymentdate: stats?.shistory?.[0].paymentdate,
            generate: stats?.shistory?.[0].invoice,
            invoice: stats?.shistory?.[0].invoice,
        };        
    });

    const planListData = superUserInfo?.planlist?.map((plan, idx) => {
        return {
            select:"",
            id: idx+1,
            name: plan.planname,
            product: plan.product==""?"QHRFlow":plan.product,
            trialperiod: plan.trialperiod,
            maxusers: plan.maxusers,
            maxresumes: plan.maxresumes,
            maxjds: plan.maxjds,
            monthly: plan.monthly,   
            quarterly: plan.quarterly,            
            hyearly: plan.hyearly,
            yearly: plan.yearly,
            addonuseramt: plan.addonuseramt,
            addonresumeamt: plan.addonresumeamt,           
            addonjdsamt: plan.addonjdsamt, 
            vendorconnect: plan.vendorconnect,            
        };
    });    


    const mySubscriptionListData = superAdminInfo?.subscriptionstats?.map((stats, idx) => {
        var stype = getSubType(stats?.shistory?.[0].status)
        var sduration = stype=="TRIAL"?stats?.shistory?.[0].trialperiod :stats?.shistory?.[0].duration + " Months"
        return {
            select:"",
            id:idx+1,
            planname: stats?.shistory?.[0].planname,
            type:stype,
            substatus: stats?.shistory?.[0].status,
            duration: sduration,
            startdate: convertDateFromTStoDate(stats?.shistory?.[0].startdate),
            enddate: convertDateFromTStoDate(stats?.shistory?.[0].enddate),
            paymentstatus: stats?.shistory?.[0].paymentstatus,
            planamount:stats?.shistory?.[0].planamount,
            paymentdate: stats?.shistory?.[0].paymentdate,
            referencenumber: stats?.shistory?.[0].paymentmethod,
            bankname:"",
        };
    });   

    const handleCurrentViewProfile = () =>{
        setCurrentView("profile")
    }
    const handleCurrentViewResumeQuality = () =>{
        setCurrentView("resume_analysis") 
    }

    return (

        <div className="superuser-summary-wrapper">
      {currentView !== "profile" && (
        <>
            <div className="section-header">
                <h3 className="title">Super User Analytics  - Version {superUserInfo?.version}</h3>

            </div>
            <div className="jd-summary-buttons-wrapper">
                <Button
                    className={`jd-summary-btn ${
                        currentView === "analytics" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("analytics")}
                >
                    Analytics
                </Button>                
                <Button
                    className={`jd-summary-btn ${
                        currentView === "summary" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("summary")}
                >
                    Account Summary
                </Button>
                <Button
                    className={`jd-summary-btn ${
                        currentView === "documents" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("documents")}
                >
                    Step 1: Document Verification
                </Button>
                <Button
                    className={`jd-summary-btn ${
                        currentView === "free" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("free")}
                >
                    Step 2: Configure Trial Users
                </Button>
                <Button
                    className={`jd-summary-btn ${
                        currentView === "paid" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("paid")}
                >
                   Step 2: Configure Subscriptions
                </Button> 
                <Button
                    className={`jd-summary-btn ${
                        currentView === "payments" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("payments")}
                >
                  Step 3: Payment Details
                </Button>                 
                <Button className={`jd-summary-btn ${
                        currentView === "plans" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("plans")}>
                    QHRFLOW Subscription Plan
                </Button>  
                
                <Button className={`jd-summary-btn ${
                        currentView === "mysubscription" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("mysubscription")}>
                    My Subscription
                </Button>                                                                             
            </div>
        </>
      )}
            {superUserInfo != null? (
                <div className="jd-summary-wrapper">
                    {
                    currentView === "documents" ?(
                        <SuperUserTableSelectable
                        isClickable
                        titleList={documentsListTable}
                        data={documentsListData}
                        extraData = {extraData}
                        isEditField = {true}
                        setCurrentView={handleCurrentViewProfile}
                        currentView = {currentView}
                    />
                    )
                    :currentView === "free" ? (
                        <SuperUserTableSelectable
                            isClickable
                            titleList={freeListTable}
                            data={getfreeListData()}
                            isEditField = {true}
                            extraData = {getfreeExtraData()}
                            isResumePage
                            setCurrentView={setCurrentView}
                            currentView = {currentView}
                        />
                    ):currentView === "paid" ? (
                          <SuperUserTableSelectable
                                titleList={subscriptionListTable}
                                data={getSubListData()}
                                extraData = {extraData}
                                isEditField = {true}
                                setCurrentView={handleCurrentViewResumeQuality}
                                currentView = {currentView}
                          /> 
                    ):currentView === "payments" ? (
                          <SuperUserPriceTableSelectable
                                titleList={paymentListTable}
                                data={paymentListData}
                                setCurrentView={handleCurrentViewResumeQuality}
                                currentView = {currentView}
                                isEditField = {true}
                          />                     
                    ):currentView === "plans" ? (
                           <SuperUserPlanTableSelectable
                                isClickable
                                titleList={planListTable}
                                isEditField = {true}
                                data={planListData}
                                setCurrentView={setCurrentView}
                                currentView = {currentView}
                                version ={superUserInfo?.version}
                          />                                                                                                                      
                    ):currentView === "mysubscription" ? (
                        <>
                          <SuperAdminPriceTableSelectable
                                isClickable
                                titleList={mySubscriptionTable}
                                data={mySubscriptionListData}
                                isResumePage
                                setCurrentView={setCurrentView}
                                currentView = {currentView}
                                columnWidth={SUBSCRIPTION_TABLE_COLUMNS_WIDTH}
                                
                          />
                        </>         
                    ):currentView === "analytics" ? (
                        <>
                          <QuallyhireProductAnalytics
                          />
                        </>                                                                                                                
                    ) : (                        
                        <>
                            <SuperUserTableSelectable
                                isResumePage
                                isEditField = {false}
                                titleList={summaryListTable}
                                data={summaryData}
                                selectable= "C Only"
                            />                            
                        </>
                    )}
                    
                </div>
            ) : (
                <Empty style={{ margin: "60px" }} >
                    <h4>SuperUser Dash Board</h4>
                </Empty>
            )}         
        </div>
    );
}
